import rg4js, { RaygunPayload } from 'raygun4js';
import { ConfigurationService } from '../configuration.service';
import { ClientSideStorageService } from '../client-side-storage.service';
import { ClientSideStorageType } from '../../models/client-side-storage-type.enum';
import LogServiceHelper from './log.service.helper';

class LogService {
  public static readonly disableLoggingCssClassName = 'disable-logging';
  public static init() {
    const apiKey = ConfigurationService.get('raygun.apikey');
    if (apiKey && ClientSideStorageService.isConsentGiven(ClientSideStorageType.Analytics)) {
      const filterSensitiveDataRegex = /disable-logging\D*/;
      rg4js('apiKey', apiKey);
      rg4js('setVersion', '2.1.7374-master'); // Placeholder for version number, replaced during deployment by update-raygun-version.sh
      rg4js('enableCrashReporting', true);
      rg4js('options', { ignore3rdPartyErrors: true });
      rg4js('setFilterScope', 'all');
      rg4js('filterSensitiveData', [filterSensitiveDataRegex]);
      rg4js('onBeforeSend', (payload: RaygunPayload) => {
        if (payload && payload.Details) {
          payload.Details = LogService.scrubSensitiveData(payload.Details) as RaygunPayload['Details'];
        }

        return payload;
      });
    }
  }

  public static logError(error: unknown, logMessage?: string) {
    if (!ConfigurationService.get('raygun.apikey') || !ClientSideStorageService.isConsentGiven(ClientSideStorageType.Analytics)) return;
    const normalizedError = LogServiceHelper.normalizeError(error);
    const raygunErrorPayload = {
      message: logMessage || normalizedError.message,
      stack: normalizedError.stack,
    };
    if (logMessage) {
      rg4js('send', { error: raygunErrorPayload, tags: ['Custom error'], customData: { message: normalizedError.message } });
    } else {
      rg4js('send', { error: raygunErrorPayload, tags: ['Custom error'] });
    }
  }

  private static scrubSensitiveData(obj: unknown): unknown {
    if (Array.isArray(obj)) {
      return obj.map(LogService.scrubSensitiveData);
    } else if (obj && typeof obj === 'object') {
      const scrubbedObject: Record<string, unknown> = {};
      Object.keys(obj).forEach((key) => {
        const value = (obj as Record<string, unknown>)[key];
        if (key === 'CustomData' && typeof value === 'object' && value !== null) {
          const customData = value as Record<string, unknown>;
          if (typeof customData.selector === 'string' && customData.selector.includes(LogService.disableLoggingCssClassName)) {
            customData.text = '[REDACTED]';
          }
          scrubbedObject[key] = customData;
        } else {
          scrubbedObject[key] = LogService.scrubSensitiveData(value);
        }
      });
      return scrubbedObject;
    }
    return obj;
  }
}

export default LogService;

